export default {
    title: 'E-Mail',
    label: 'E-Mail',
    content: 'Please {contact} the administrator to change your e-mail address',
    contact: 'contact'
}
